import { reduce, pipe, path } from 'ramda'
import { useSelector } from '@/hooks/redux'

const versions = {
  custom_contract: 'v1',
  pad: 'v2'
}

type BetaUser = {
  custom_contract: number[]
  pad: number[]
}

const useBetaUser = (): BetaUser =>
  useSelector(
    pipe(
      path(['session', 'beta_users', 'web']),
      (v?: {}) => (typeof v === 'object' ? Object.entries(v) : []),
      reduce(
        (acc, [key, value]) => {
          const feat = key as keyof BetaUser
          const lookup = versions[feat]
          if (lookup) {
            const users: number[] | undefined = path([lookup, 'user_ids'], value)
            if (users) acc[feat] = users
          }
          return acc
        },
        { custom_contract: [], pad: [] } as BetaUser
      )
    )
  )

export default useBetaUser
